import { Action, createReducer, on } from '@ngrx/store';
import { IUserLockedUpdateResponse, IUserLockedUpdateRequest } from '../models/lock.model';
import { IGenericError, ErrorResponse } from 'src/app/core/models/generic-models';
import { loadUnLockedRequest, loadUnLockedResponse, loadUnLockedFailure } from '../actions/locked.actions';

export const unlockFeatureKey = 'unlock';

export interface UnLockState {
  unlockedRequest: IUserLockedUpdateRequest;
  unlockedResponse: IUserLockedUpdateResponse;
  unlockedFailure: IGenericError<ErrorResponse>;
}

export const initialState: UnLockState = {
  unlockedRequest: undefined,
  unlockedResponse: undefined,
  unlockedFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadUnLockedRequest, (state, action) => ({
    ...state,
    unlockedRequest: action.request
  })),
  on(loadUnLockedResponse, (state, action) => ({
    ...state,
    unlockedResponse: action.response
  })),
  on(loadUnLockedFailure, (state, action) => ({
    ...state,
    unlockedFailure: action.error
  }))
);

export const getUserUnLockedRequest = (state: UnLockState) => state.unlockedRequest;
export const getUserUnLockedResponse = (state: UnLockState) => {
  return state.unlockedResponse;
};
export const getUserUnLockedFailure = (state: UnLockState) => state.unlockedFailure;
